const colors = {
  BACKGROUND: "#FAFBFC",
  BLACK: "#151D48",
  GREEN: "#08a467",
  GREY_1: "#F2F2F7",
  GREY_2: "#E5E5EA",
  GREY_3: "#D1D1D6",
  GREY_4: "#C7C7CC",
  GREY_5: "#AEAEB2",
  GREY_6: "#8E8E93",
  GREY_7: "#737791",
  ORANGE: "#FFA500",
  CORAL: "#FF7F50",
  CORAL_LIGHT: "#FF9A66",
  PURPLE: "#7469B6",
  PURPLE_LIGHT: "#AD88C6",
  PURPLE_LIGHTER: "#E1AFD1",
  PURPLE_LIGHTEST: "#FFE6E6",
  RED: "#FF3B30",
  RED_DARK: "#DC2626",
  WHITE: "#FFFFFF",
  YELLOW_LIGHT: "#FFEAA7",

  // Gradients
  GRADIENT_PURPLE: "linear-gradient(135deg, #7469B6 0%, #AD88C6 100%)",
  GRADIENT_RED: "linear-gradient(135deg, #EF4444 0%, #DC2626 100%)",
  GRADIENT_BACKGROUND: "linear-gradient(180deg, rgba(116, 105, 182, 0.03) 0%, transparent 100%)",

  // Glassmorphism
  GLASS_WHITE: "rgba(255, 255, 255, 0.9)",
  GLASS_BORDER: "rgba(255, 255, 255, 0.5)",

  // Shadow colors (for rgba usage)
  SHADOW_LIGHT: "rgba(31, 38, 135, 0.08)",
  SHADOW_MEDIUM: "rgba(31, 38, 135, 0.15)",
  SHADOW_PURPLE_LIGHT: "rgba(116, 105, 182, 0.15)",
  SHADOW_PURPLE_MEDIUM: "rgba(116, 105, 182, 0.25)",
  SHADOW_PURPLE_STRONG: "rgba(116, 105, 182, 0.35)",
  FOCUS_RING: "rgba(116, 105, 182, 0.24)",
};

export type ColorsType = (typeof colors)[keyof typeof colors];
export default colors;
